"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

var _TextField = _interopRequireDefault(require("./TextField"));

var _alarmIcon = require("../../icons/alarmIcon");

var _vanillaTextMask = require("vanilla-text-mask");

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _WithTextComponentMethods = _interopRequireDefault(require("../../utils/WithTextComponentMethods"));

var FormioUtils = _interopRequireWildcard(require("../../utils/utils"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TextField =
/*#__PURE__*/
function (_WithLogic) {
  _inherits(TextField, _WithLogic);

  function TextField() {
    _classCallCheck(this, TextField);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextField).apply(this, arguments));
  }

  _createClass(TextField, [{
    key: "setValue",
    value: function setValue(value, flags) {
      if (!this.component.inputMask && !this.component.inputMasks) {
        value = this.component.onlyUppercase ? value.toUpperCase() : value;
      }

      return _get(_getPrototypeOf(TextField.prototype), "setValue", this).call(this, value, flags);
    }
  }, {
    key: "getView",
    value: function getView(value, id) {
      if (!value) {
        return '';
      }

      var wrapperId = id || this.options.name;
      var wrapperStyles = "display: inline-flex; align-items: center;";

      if (typeof value !== 'string') {
        if (Array.isArray(value)) {
          var values = value; // предполагаем, что value имеет тип {value: string, maskName: string}[]

          if (value[0] && value[0].value !== undefined) {
            values = value.map(function (value) {
              return value.value;
            });
          }

          values = values.map(function (value, index) {
            return "<span id=\"".concat(wrapperId, "[").concat(index, "]\" style=\"").concat(wrapperStyles, "\">").concat(value, "</span>");
          });
          return values.join(', ');
        }

        return "<span id=\"".concat(wrapperId, "\" style=\"").concat(wrapperStyles, "\">").concat(value.value, "</span>");
      }

      if (this.component.inputMask) {
        value = (0, _vanillaTextMask.conformToMask)(value, FormioUtils.getInputMask(this.component.inputMask)).conformedValue;
      }

      var widget = this.widget;

      if (widget && widget.getView) {
        return widget.getView(value);
      }

      var protectedValue = value.replace(/</g, '&lt;');
      protectedValue = protectedValue.replace(/>/g, '&gt;');
      return "<span id=\"".concat(wrapperId, "\" style=\"").concat(wrapperStyles, "\">").concat(protectedValue.toString(), "</span>");
    }
  }, {
    key: "addFlkMessage",
    value: function addFlkMessage(errorMessage, elementId) {
      var element = document.querySelector("[id='".concat(elementId, "']")) || this.valueElement;
      var iconStyle = 'border-radius: 50%; margin-left: 4px; display: inline-flex; ';

      if (element && element.flkIcon) {
        return;
      }

      var icon;

      if (this.error && errorMessage) {
        icon = this.ce('span', {
          style: iconStyle + 'background: #F44336;',
          title: errorMessage
        });
        icon.innerHTML = _alarmIcon.alarmIcon;
      }

      element.flkIcon = icon;
      element.flkIcon && element.appendChild(element.flkIcon);
    }
  }, {
    key: "onChange",
    value: function onChange(flags, fromRoot) {
      if (!this.component.inputMask && !this.component.inputMasks && !this.component.multiple) {
        this.setValue(this.dataValue, flags);
      }

      _get(_getPrototypeOf(TextField.prototype), "onChange", this).call(this, flags, fromRoot);

      if (this.wordCount) {
        var value = this.component.editor ? this.removeTags(this.dataValue, true) : this.dataValue;
        var clearValue = value.trim();
        var wordCount = !!clearValue ? clearValue.split(/\s+/).length : 0;
        var wordCounterName = 'words';
        this.setCounter(wordCounterName, this.wordCount, wordCount, this.maxWordCount);
      }

      if (this.charCount) {
        var _value = this.component.editor ? this.removeTags(this.dataValue) : this.dataValue;

        if (this.originalComponent.deleteSpaces) {
          _value = _value.replace(/\s/g, ''); // удаляем все пробелы
        }

        var charachterCount = _value.length;
        var charachterCounterName = 'characters';
        this.setCounter(charachterCounterName, this.charCount, charachterCount, this.maxCharCount);
      }

      if (this._inputMask) {
        var defaultValue = this.defaultValue;
        var mask = (0, _vanillaTextMask.conformToMask)(defaultValue, this._inputMask).conformedValue;

        if (_typeof(this.dataValue) === 'object' && !this.dataValue.value) {
          this.dataValue.value = mask;
        } else if (!this.dataValue) {
          this.dataValue = mask;
        }
      }
    }
  }, {
    key: "setCounter",
    value: function setCounter(type, element, count, max) {
      if (max) {
        var remaining = max - count;

        if (remaining > 0) {
          this.removeClass(element, 'text-danger');
        } else {
          this.addClass(element, 'text-danger');
        }

        element.innerHTML = this.t("{{ remaining }} ".concat(type, " remaining."), {
          remaining: remaining
        });
      } else {
        // поменял на нормальный ключ, было {{ count }} ${type}
        element.innerHTML = this.t(type, {
          count: count
        });
      }
    }
  }, {
    key: "baseSetValueAt",
    value: function baseSetValueAt(index, value, flags) {
      flags = flags || {};

      if (!flags.noDefault && _lodash.default.isNil(value)) {
        value = this.defaultValue;
      }

      var input = this.performInputMapping(this.inputs[index]);

      if (input.mask && _typeof(value) !== 'object') {
        input.mask.textMaskInputElement.update(value);
      } else {
        input.value = value;
      }

      if (input.widget) {
        input.widget.setValue(value);
      }
    }
  }, {
    key: "setValueAt",
    value: function setValueAt(index, value, flags) {
      flags = flags || {};

      if (!this.isMultipleMasksField) {
        return this.baseSetValueAt(index, value, flags);
      }

      var defaultValue = flags.noDefault ? this.emptyValue : this.defaultValue;

      if (!value) {
        if (defaultValue) {
          value = defaultValue;
        } else {
          value = {
            maskName: this.component.inputMasks[0].label
          };
        }
      } //if value is a string, treat it as text value itself and use default mask or first mask in the list


      var defaultMaskName = _lodash.default.get(defaultValue, 'maskName', '');

      if (typeof value === 'string') {
        value = {
          value: value,
          maskName: defaultMaskName ? defaultMaskName : this.component.inputMasks[0].label
        };
      }

      var maskName = value.maskName || '';
      var textValue = value.value || '';
      var textInput = this.inputs[index] ? this.inputs[index].text : undefined;
      var maskInput = this.inputs[index] ? this.inputs[index].mask : undefined;

      if (textInput && maskInput) {
        maskInput.value = maskName;
        textInput.value = textValue;
        this.updateMask(textInput, maskName);
      }
    }
  }, {
    key: "defaultValue",
    get: function get() {
      var defaultValue = this.emptyValue;

      if (this.component.defaultValue) {
        defaultValue = this.component.defaultValue;
      }

      if (this.component.customDefaultValue && !this.options.preview) {
        defaultValue = this.evaluate(this.component.customDefaultValue, {
          value: ''
        }, 'value');
      }

      if (this._inputMask) {
        if (typeof defaultValue === 'string') {
          defaultValue = (0, _vanillaTextMask.conformToMask)(defaultValue, this._inputMask).conformedValue;
        } else {
          defaultValue = (0, _vanillaTextMask.conformToMask)(defaultValue.value, this._inputMask).conformedValue;
        }

        if (!FormioUtils.matchInputMask(defaultValue, this._inputMask)) {
          defaultValue = '';
        }
      } // Let the widget provide default value if none is already provided.


      if (!defaultValue) {
        var widget = this.widget;

        if (widget) {
          defaultValue = widget.defaultValue;
        }
      } // Clone so that it creates a new instance.


      return _lodash.default.clone(defaultValue);
    }
  }]);

  return TextField;
}((0, _WithLogic2.default)((0, _WithTextComponentMethods.default)(_TextField.default)));

exports.default = TextField;